module.exports = __webpack_public_path__ + "images/37b644f325f9c4f746b7f9469e5b6437.png";